import * as React from "react";
const SvgFiRrAlicorn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-alicorn_svg__a)">
      <path d="M22.79 6.764c-1.454-.625-2.52-1.454-3.189-2.475L23.856.777c.349-.33.006-.904-.45-.752l-4.407 1.61c.229-3.048-2.572-1.23-2.914.632-2.685.83-3.752 3.416-4.017 5.345C9.544 6.515 8.179 4.926 6.77 3.487a1.6 1.6 0 0 0-1.801-.35 1.61 1.61 0 0 0-.968 1.573c.059 1.101.173 3.235 1.195 5.436a4 4 0 0 0-.325.357C2.769 11.213-.009 13.301 0 19a1 1 0 0 0 2 0c0-2.796.671-4.748 1.997-5.83.067 2.06.945 4.06 1.536 5.91-.204 1.291-.53 2.85.489 3.901 1.578 1.927 4.953.904 5.186-1.583L11.383 20H13v1c.104 3.956 5.897 3.955 6 0v-2.395l.385-1.81c.653-1.948.648-3.893.615-5.913l2.237-.28c1.995-.213 2.409-3.08.553-3.838m-3.038 2.134A2 2 0 0 0 18 10.882v2.016c0 1.25-.166 2.042-.555 3.412 0 0-.445 2.12-.445 2.19V21a1.001 1.001 0 0 1-2 0v-2a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-.992.875l-.284 2.274a.97.97 0 0 1-.962.85c-.572.014-1.054-.538-.96-1.103l.243-1.76c-.24-2.233-2.275-4.986-1.265-7.162.547.705 3.509 4.234 4.579 2.54a1 1 0 0 0-.343-1.372c-3.265-1.959-4.163-4.903-4.434-7.49 1.409 1.45 3.468 3.401 6.644 4.31.614.193 1.292-.318 1.275-.962v-.483c.009-.43.175-3.984 3.245-4.463.749 1.984 2.345 3.514 4.744 4.565l-2.237.28z" />
      <path d="m4.868 10.509.005-.006c-.017.004-.039.01-.005.006" />
    </g>
    <defs>
      <clipPath id="fi-rr-alicorn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlicorn;
